export default {
	currency: {
		style: 'currency',
		currency: 'EUR',
		currencyDisplay: 'symbol'
	},
	currencyDecimals: {
		style: 'currency',
		currency: 'EUR',
		currencyDisplay: 'symbol',
		minimumFractionDigits: 2,
		maximumFractionDigits: 20
	},
	number: {
		maximumFractionDigits: 20
	},
	numberShort: {
		maximumFractionDigits: 3
	},
	numberShorter: {
		maximumFractionDigits: 2
	}
}
